import { createSelector } from 'reselect'

import selectIsAnybodyHasCafeteria from '../../CafeteriaPage/selectIsAnybodyHasCafeteria'
// import replenishAvailable from '../selectReplenishAvailable'
// import transferAvailable from '../selectTransferAvailable'


const selectNavigationAvalilability = createSelector(
  [
    selectIsAnybodyHasCafeteria,
    // replenishAvailable,
    // transferAvailable,
    state => !!state.user.parent,
    state => state.user.balance.primaryBalanceHidden,
  ],
  (
    isChildrenAvailable,
    // isReplenishAvailable,
    // isTransferAvailable,
    isParent,
    primaryBalanceHidden
  ) => ({
    isMyAvailable: !primaryBalanceHidden,
    isChildrenAvailable: isParent && isChildrenAvailable,
    // isReplenishAvailable,
    // isTransferAvailable,
  })
)

export default selectNavigationAvalilability
